export default __webpack_public_path__ + "static/media/aws.9c34cc43.png";